
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as ShrinkIconComponent } from "./shrink-icon.svg";

export const ShrinkIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <ShrinkIconComponent {...props} />;
};
